var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconKeyBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-320-504h1440v985H-320z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8B9BB3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 25a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 2a5 5 0 1 1 0-10 5 5 0 0 1 0 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L11.586 13 10.5 11.914 9.146 13.27a1 1 0 1 1-1.415-1.415l2.062-2.061a1 1 0 0 1 1.414 0l8.5 8.5a1 1 0 0 1-1.414 1.414L13 14.414z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "M18 36C8.059 36 0 27.941 0 18S8.059 0 18 0s18 8.059 18 18-8.059 18-18 18zm0-1.846c8.922 0 16.154-7.232 16.154-16.154S26.922 1.846 18 1.846 1.846 9.078 1.846 18 9.078 34.154 18 34.154z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyBig);
export default __webpack_public_path__ + "static/media/icon-key-big.0a7df53d4a76613a37e95f7bb95ee2fc.svg";
export { ForwardRef as ReactComponent };